// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
// Components, Layouts, Pages
import { JobFieldsComponent } from '..';
// Others
import { IFormJob } from '~/utils/interface/job';
// Styles, images, icons
import styles from './CreateJobFieldsTab.module.scss';

type Props = {
  onEdit: (data: IFormJob, type: string) => void;
  onCancelEdit: () => void;
};

const cx = classNames.bind(styles);

const CreateJobFieldsTab = (props: Props) => {
  //#region Destructuring Props
  const { onEdit, onCancelEdit } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} className={cx('container')} id='createJobFieldsTabComponent'>
      <JobFieldsComponent onEdit={onEdit} onCancelEdit={onCancelEdit} />
    </Box>
  );
};

export default CreateJobFieldsTab;
